export function getImageUrl(id: string) {
  return `${process.env.REACT_APP_API_HOST || ""}/rest/image/${id}`;
}
